import { render, staticRenderFns } from "./clientLayout.vue?vue&type=template&id=28d6b326&"
import script from "./clientLayout.vue?vue&type=script&lang=js&"
export * from "./clientLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports